import { QueryClient } from 'react-query';

/** Keep this in a dedicated folder so it can be used in state stores etc */
export const query_client = new QueryClient({
  defaultOptions: {
    queries: {
      /** Refetch data every 5 minutes */
      refetchInterval: 1000 * 60 * 5,
    },
  },
});
